function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
import socialShareSheet from "./social-share.css?polyfill=type-css" ;

import themeSheet from "../../styles/theme.css?polyfill=type-css" ;

import {defineCustomElement} from "web-social-share";
export default class SocialShare extends HTMLElement {
  #show = false;
  #shareConfig;
  constructor() {
    super();
    const socialShareUrl = typeof window !== "undefined" ? window.location.href : "";
    this.#shareConfig = {
      displayNames: true,
      config: [{
        facebook: {
          socialShareUrl
        }
      }, {
        twitter: {
          socialShareUrl
        }
      }, {
        pinterest: {
          socialShareUrl
        }
      }]
    };
  }
  connectedCallback() {
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: "open"
      });
    }
    _optionalChain([this, 'optionalAccess', _ => _.shadowRoot, 'optionalAccess', _2 => _2.adoptedStyleSheets, 'optionalAccess', _3 => _3.push, 'call', _4 => _4(themeSheet, socialShareSheet)]);
    this.render();
    if (typeof window !== "undefined") {
      defineCustomElement();
      setTimeout(() => {
        const shareElement = _optionalChain([this, 'access', _5 => _5.shadowRoot, 'optionalAccess', _6 => _6.querySelector, 'call', _7 => _7("web-social-share")]);
        if (!shareElement) {
          console.error("Share element not found");
          return;
        }
        shareElement.share = this.#shareConfig;
        shareElement.addEventListener("closed", () => {
          this.#show = false;
        });
      }, 1000);
    }
  }
  toggleShowSocialShare() {
    this.#show = !this.#show;
    _optionalChain([this, 'access', _8 => _8.shadowRoot, 'optionalAccess', _9 => _9.querySelector, 'call', _10 => _10("web-social-share"), 'optionalAccess', _11 => _11.setAttribute, 'call', _12 => _12("show", this.#show ? "true" : "")]);
  }
  render() {
        const template = document.createElement('template');
    template.innerHTML = `<div>
        <h2 class="header">Interact + Share</h2>

        <button type="button" class="btn" onclick="this.getRootNode().host.toggleShowSocialShare(event)">
          <svg class="svg-inline--fa fa-share-alt fa-w-14" aria-hidden="true" data-prefix="fas" data-icon="share-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
            <path fill="currentColor" d="M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"></path>
          </svg>
          SHARE THIS PAGE
        </button>

        <web-social-share>
          <i class="fa fa-facebook" slot="facebook"></i>
          <i class="fa fa-twitter" slot="twitter"></i>
          <i class="fa fa-pinterest" slot="pinterest"></i>
        </web-social-share>
      </div>`;
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: 'open'
      });
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    } else {
      this.shadowRoot.innerHTML = template.innerHTML;
    }

  }
}
customElements.define("as-social-share", SocialShare);
